import { createContext, useContext } from 'react';
import type { Tone } from '../components/ui/toneStyles';

export interface ToastOptions {
    tone?: Tone;
    /** Milliseconds before auto-dismiss. Defaults to 2200ms (Toast's own default) when omitted. */
    duration?: number;
}

export interface ToastContextValue {
    show: (message: string, opts?: ToastOptions) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

export const useToast = (): ToastContextValue => {
    const ctx = useContext(ToastContext);
    if (!ctx) throw new Error('useToast must be used within AppShell');
    return ctx;
};
